import { useQuery } from 'hooks/useCustomQuery';
import { getAllAPIUsers } from 'API/APIKeys';

/** (3153) The company's API users, to find API keys that are expiring. */
const useGetCompanyApiUsers = (companyId, options = {}) =>
    useQuery({
        queryKey: ['dashboardHome', 'apiUsers', companyId],
        queryFn: async () => (await getAllAPIUsers(companyId)) || [],
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetCompanyApiUsers;
